import { type ReactNode, createContext, useContext, useMemo } from 'react';

const ModuleSkeletonContext = createContext<{ details: ReactNode; module: ReactNode }>(undefined);

export const useModuleSkeletonContext = () => {
    const context = useContext(ModuleSkeletonContext);
    return context;
};

type ModuleSkeletonProviderProps = {
    children: ReactNode;
    initDetailsSkeleton: ReactNode;
    initModuleSkeleton: ReactNode;
};

export function ModuleSkeletonProvider({ children, initDetailsSkeleton, initModuleSkeleton }: ModuleSkeletonProviderProps) {
    const memoizedValue = useMemo(
        () => ({
            details: initDetailsSkeleton,
            module: initModuleSkeleton,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return <ModuleSkeletonContext.Provider value={memoizedValue}>{children}</ModuleSkeletonContext.Provider>;
}
